// extracted by mini-css-extract-plugin
module.exports = {"logo":"Io3D"};